import { render, staticRenderFns } from "./commonfinance.vue?vue&type=template&id=d9a20746&scoped=true"
import script from "./commonfinance.vue?vue&type=script&lang=js"
export * from "./commonfinance.vue?vue&type=script&lang=js"
import style0 from "./commonfinance.vue?vue&type=style&index=0&id=d9a20746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a20746",
  null
  
)

export default component.exports